// import * as PIXI from 'pixi.js';
// import image4 from '../../assets/backgroundImages/1.png';
// import { useEffect } from "react";
// import { useSelector } from "react-redux";

// const PixiBackgrounds = () => {
//   const canvas = useSelector((state) => state.canvas.app);
//   const dimensions = useSelector((state) => state.canvas.dimensions);
//   const selectedMockup = useSelector((state) => state.mockupCategories.selectedMockup) || [];

//   useEffect(() => {
//     if (canvas && canvas.stage) {
//       const cameraContainer = canvas.cameraContainer;

//       //
//       // 1) Base T-shirt layer (the background)
//       //
//       if (selectedMockup.design_layer) {
//         const baseTexture = PIXI.Texture.from(selectedMockup.design_layer || image4);
//         const baseSprite = new PIXI.Sprite(baseTexture);
//         baseSprite.width = dimensions.width;
//         baseSprite.height = dimensions.height;
//         // Normal blend mode, full opacity
//         baseSprite.blendMode = PIXI.BLEND_MODES.NORMAL;
//         baseSprite.alpha = 1.0;
//         cameraContainer.addChild(baseSprite);
//       }

//       //
//       // 2) Shadow layer on top (Multiply blend)
//       //
//       if (selectedMockup.shadow_layer) {
//         const shadowTexture = PIXI.Texture.from(selectedMockup.shadow_layer || image4);
//         const shadowSprite = new PIXI.Sprite(shadowTexture);
//         shadowSprite.width = dimensions.width;
//         shadowSprite.height = dimensions.height;
//         shadowSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY;
//         // Tweak alpha as needed for realism
//         shadowSprite.alpha = 0.5;
//         cameraContainer.addChild(shadowSprite);
//       }

//       //
//       // 3) Highlight layer on top (Screen blend)
//       //
//       if (selectedMockup.additional_layer) {
//         const highlightTexture = PIXI.Texture.from(selectedMockup.additional_layer || image4);
//         const highlightSprite = new PIXI.Sprite(highlightTexture);
//         highlightSprite.width = dimensions.width;
//         highlightSprite.height = dimensions.height;
//         highlightSprite.blendMode = PIXI.BLEND_MODES.SCREEN;
//         // Tweak alpha as needed
//         highlightSprite.alpha = 0.5;
//         cameraContainer.addChild(highlightSprite);
//       }
//     }
//   }, [dimensions, canvas, selectedMockup]);

//   return null;
// };

// export default PixiBackgrounds;

import * as PIXI from "pixi.js";
import image4 from "../../assets/backgroundImages/1.png";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const PixiBackgrounds = () => {
  const canvas = useSelector((state) => state.canvas.app);
  const dimensions = useSelector((state) => state.canvas.dimensions);
  const selectedMockup =
    useSelector((state) => state.mockupCategories.selectedMockup) || [];

  useEffect(() => {
    if (canvas && canvas.stage) {
      const cameraContainer = canvas.cameraContainer;
      cameraContainer.sortableChildren = true;
   
      if (selectedMockup.design_layer) {
        const texture4 = PIXI.Texture.from(
          selectedMockup.design_layer || image4
        );
        const background4 = new PIXI.Sprite(texture4);
        background4.isMockupSprite = true;
        background4.width = dimensions.width;
        background4.height = dimensions.height;
        cameraContainer.addChild(background4);
      }
      if (selectedMockup.additional_layer) {
        const texture2 = PIXI.Texture.from(
          selectedMockup.additional_layer || image4
        );
        const background2 = new PIXI.Sprite(texture2);
        background2.isAdditionalSprite = true;
        background2.width = dimensions.width;
        background2.height = dimensions.height;
        cameraContainer.addChild(background2);
      }
      if (selectedMockup.shadow_layer) {
        // Check if a shadow sprite is already added
        const shadowExists = cameraContainer.children.some(child => child.isShdowSprite);
        if (!shadowExists) {
          const texture1 = PIXI.Texture.from(
            selectedMockup.shadow_layer || image4
          );
          const background1 = new PIXI.Sprite(texture1);
          background1.isShdowSprite = true;
          background1.width = dimensions.width;
          background1.height = dimensions.height;
          background1.zIndex = 20; 
          background1.interactive = false;
        
          // background1.hitArea = new PIXI.Rectangle(0, 0, dimensions.width, dimensions.height);
          background1.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
         
          cameraContainer.addChild(background1);
        }
      }
    }
  
  }, [dimensions,canvas, selectedMockup]);

  return null;
};

export default PixiBackgrounds;
